import axios from 'axios';
import { getAuthHeader } from './otpAuthService';

// REST: usare REACT_APP_API_BASE_URL (include già /api), NON REACT_APP_API_URL (GraphQL).
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

export interface SchedaBadgeRete {
  idScheda: string;
  nome: string;
  indirizzo: string;
  principale: boolean;
}

export interface BadgeAssociato {
  inRegola: boolean;
  reteCertificata: SchedaBadgeRete[];
  /** Certificato ATTIVO ma nessuna scheda visibile sulla mappa pubblica. */
  certificatoSenzaScheda: boolean;
}

/** Badge a cui ha diritto l'associato autenticato (GET /api/associate-badge). */
export const getBadge = async (): Promise<BadgeAssociato> => {
  const { data } = await axios.get(`${API_BASE_URL}/associate-badge`, { headers: getAuthHeader() });
  return data.data;
};
